var _excluded = ["className", "style", "onClick", "theme", "size", "fill", "strokeWidth", "strokeLinecap", "strokeLinejoin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
import { DEFAULT_ICON_CONFIGS } from './config';
var hyphenateRE = /\B([A-Z])/g;
var defaultConfig = DEFAULT_ICON_CONFIGS;

function withWrapper(type, Component) {
  function Icon(props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick,
        _props$theme = props.theme,
        theme = _props$theme === void 0 ? defaultConfig.theme : _props$theme,
        _props$size = props.size,
        size = _props$size === void 0 ? defaultConfig.size : _props$size,
        _props$fill = props.fill,
        fill = _props$fill === void 0 ? 'currentColor' : _props$fill,
        _props$strokeWidth = props.strokeWidth,
        strokeWidth = _props$strokeWidth === void 0 ? defaultConfig.strokeWidth : _props$strokeWidth,
        _props$strokeLinecap = props.strokeLinecap,
        strokeLinecap = _props$strokeLinecap === void 0 ? defaultConfig.strokeLinecap : _props$strokeLinecap,
        _props$strokeLinejoin = props.strokeLinejoin,
        strokeLinejoin = _props$strokeLinejoin === void 0 ? defaultConfig.strokeLinejoin : _props$strokeLinejoin,
        extra = _objectWithoutProperties(props, _excluded);

    var classNameArr = ["".concat(usePrefixCls('icon')), "".concat(usePrefixCls('icon-' + type.replace(hyphenateRE, '-$1').toLowerCase()))];

    if (className) {
      classNameArr.push(className);
    }

    var colors = Array.isArray(fill) ? fill : [fill];
    var config = useMemo(function () {
      var config = {
        outFillColor: colors[1] || defaultConfig.outFillColor,
        innerStrokeColor: colors[2] || defaultConfig.innerStrokeColor,
        innerFillColor: colors[3] || defaultConfig.innerFillColor
      };

      if (theme === 'outline') {
        Object.assign(config, {
          outFillColor: 'transparent',
          innerFillColor: 'transparent',
          innerStrokeColor: colors[0]
        });
      }

      if (theme === 'filled') {
        Object.assign(config, {
          outFillColor: colors[0],
          innerFillColor: '#FFF',
          innerStrokeColor: '#FFF'
        });
      }

      if (theme === 'two-tone') {
        Object.assign(config, {
          outFillColor: colors[1] || defaultConfig.outFillColor,
          innerFillColor: colors[1] || defaultConfig.outFillColor,
          innerStrokeColor: colors[0]
        });
      }

      return config;
    }, [colors, theme]);
    return React.createElement("span", {
      className: classNameArr.join(' '),
      style: style,
      onClick: onClick
    }, React.createElement(Component, _objectSpread(_objectSpread({
      size: size,
      strokeWidth: strokeWidth,
      strokeLinecap: strokeLinecap,
      strokeLinejoin: strokeLinejoin,
      outStrokeColor: colors[0]
    }, config), extra)));
  }

  Icon.displayName = type;
  return Icon;
}

export default withWrapper;